// --- UTILIDADES ---
const roundToCents = (amount) => {
  const cents = Math.round(Number(amount) * 100);
  if (!Number.isFinite(cents) || cents === 0) return 0;
  return cents / 100;
};

export const formatCurrency = (amount, currency = 'USD') => {
  const value = roundToCents(amount);

  if (currency === 'BS') {
    const formattedAmount = new Intl.NumberFormat('es-VE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(value);
    return `Bs. ${formattedAmount}`;
  }

  return new Intl.NumberFormat('es-VE', {
    style: 'currency',
    currency: currency,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(value);
};

/** Interpreta números en formato es-VE (1.773 = mil setecientos) o US (1,773 / 1773.5). */
export const parseEsVeNumber = (raw) => {
  if (raw == null) return null;
  let text = String(raw).trim().replace(/\s/g, "").replace("$", "").replace("Bs.", "").replace("Bs", "");
  if (!text || text === "-" || text === "," || text === ".") return null;

  const negative = text.startsWith("-");
  if (negative) text = text.slice(1);
  if (!/^[\d.,]+$/.test(text)) return null;

  const hasComma = text.includes(",");
  const hasDot = text.includes(".");
  let normalized = text;

  if (hasComma && hasDot) {
    if (text.lastIndexOf(",") > text.lastIndexOf(".")) {
      normalized = text.replace(/\./g, "").replace(",", ".");
    } else {
      normalized = text.replace(/,/g, "");
    }
  } else if (hasComma) {
    const parts = text.split(",");
    if (parts.length === 2 && parts[1].length <= 2) {
      normalized = text.replace(",", ".");
    } else if (parts.slice(1).every((p) => p.length === 3)) {
      normalized = text.replace(/,/g, "");
    } else {
      normalized = text.replace(",", ".");
    }
  } else if (hasDot) {
    const parts = text.split(".");
    if (parts.length === 2 && parts[1].length <= 2) {
      normalized = text;
    } else if (parts.slice(1).every((p) => p.length === 3)) {
      normalized = text.replace(/\./g, "");
    } else if (parts.length > 2) {
      normalized = text.replace(/\./g, "");
    }
  }

  const value = parseFloat(normalized);
  if (!Number.isFinite(value)) return null;
  return negative ? -value : value;
};

export const formatDate = (timestamp) => {
  if (!timestamp) return '';
  const date = timestamp.toDate ? timestamp.toDate() : new Date(timestamp);
  const dateString = date.toLocaleDateString('es-VE', { timeZone: 'America/Caracas', day: '2-digit', month: '2-digit', year: 'numeric' });
  const timeString = date.toLocaleTimeString('es-VE', { timeZone: 'America/Caracas', hour: '2-digit', minute: '2-digit', hour12: true });
  return `${dateString} ${timeString}`;
};

export const sellerLabel = (seller) => {
  if (!seller) return "";
  if (typeof seller === "object") {
    return seller.fullName || seller.username || "";
  }
  return "";
};
